export default "__VITE_ASSET__BqpHUiGi__"